import { MessageService } from '../../../message/message.service';
import { TranslateService } from "@ngx-translate/core";
import { CoachDetails } from '../../../../shared/model/coach-details.model';
import { VideoCallService } from '../../../video-call/video-call.service';
import { Router } from "@angular/router";
import * as i0 from "@angular/core";
import * as i1 from "../../../message/message.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../../../video-call/video-call.service";
import * as i4 from "@angular/router";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "@angular/common";
import * as i7 from "../../../../shared/auth/has-any-authority.directive";
import * as i8 from "@angular/material/icon";
import * as i9 from "@angular/material/tooltip";
import * as i10 from "../../../../ng-jhipster/language/jhi-translate.directive";
function VideoCallDropdownComponent_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 7);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 8);
    i0.ɵɵelement(3, "use", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("matTooltipPosition", "above")("matTooltip", i0.ɵɵpipeBind1(1, 3, "sessionChat.button.videoIconTooltip"))("matTooltipClass", "video-icon-tool-tip");
} }
function VideoCallDropdownComponent__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 8);
    i0.ɵɵelement(1, "use", 9);
    i0.ɵɵelementEnd();
} }
function VideoCallDropdownComponent_ng_container_6_ng_container_1_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function VideoCallDropdownComponent_ng_container_6_ng_container_1_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(3); return ctx_r5.startJitsiVideoChat(); });
    i0.ɵɵelement(1, "img", 22);
    i0.ɵɵelement(2, "span", 23);
    i0.ɵɵelement(3, "span", 19);
    i0.ɵɵelementEnd();
} }
function VideoCallDropdownComponent_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("click", function VideoCallDropdownComponent_ng_container_6_ng_container_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.startVideoCall(); });
    i0.ɵɵelement(2, "img", 13);
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵelement(4, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 16);
    i0.ɵɵlistener("click", function VideoCallDropdownComponent_ng_container_6_ng_container_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.startZoomVideoChat(); });
    i0.ɵɵelement(6, "img", 17);
    i0.ɵɵelement(7, "span", 18);
    i0.ɵɵelement(8, "span", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, VideoCallDropdownComponent_ng_container_6_ng_container_1_button_9_Template, 4, 0, "button", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r3.session.started && (ctx_r3.coachDetails == null ? null : ctx_r3.coachDetails.videoChatEnabled));
} }
function VideoCallDropdownComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 10);
    i0.ɵɵtemplate(1, VideoCallDropdownComponent_ng_container_6_ng_container_1_Template, 10, 1, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.session.started && (ctx_r2.coachDetails == null ? null : ctx_r2.coachDetails.videoChatEnabled));
} }
export class VideoCallDropdownComponent {
    constructor(messageService, translateService, videoCallService, router) {
        this.messageService = messageService;
        this.translateService = translateService;
        this.videoCallService = videoCallService;
        this.router = router;
    }
    startVideoCall() {
        this.videoCallService.startVideoCall(this.session).subscribe(value => {
            this.router.navigate(['/session/video-coach', this.session.id]).then();
        }, errorResponse => {
            let error = errorResponse.error;
            let errorText = this.translateService.instant(error.errorKey);
            alert(errorText);
        });
    }
    startZoomVideoChat() {
        this.messageService.startZoomVideoChat(this.session.id).subscribe(value => {
            console.log(value);
        }, errorResponse => {
            let error = errorResponse.error;
            let errorText = this.translateService.instant(error.errorKey);
            alert(errorText);
        });
    }
    startJitsiVideoChat() {
        this.messageService.startJitsiVideoChat(this.session.id).subscribe(value => {
            console.log(value);
        }, errorResponse => {
            let error = errorResponse.error;
            let errorText = this.translateService.instant(error.errorKey);
            alert(errorText);
        });
    }
}
VideoCallDropdownComponent.ɵfac = function VideoCallDropdownComponent_Factory(t) { return new (t || VideoCallDropdownComponent)(i0.ɵɵdirectiveInject(i1.MessageService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i3.VideoCallService), i0.ɵɵdirectiveInject(i4.Router)); };
VideoCallDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VideoCallDropdownComponent, selectors: [["video-call-dropdown"]], inputs: { session: "session", coachDetails: "coachDetails" }, decls: 7, vars: 4, consts: [["ngbDropdown", "", "placement", "bottom-right", 1, "d-inline-block", "float-right", "olha-theme"], ["ngbDropdownToggle", ""], [1, "btn", "btn-secondary", "border-1", "video-icon-button", "d-flex", "justify-content-center", "align-items-center", 3, "disabled"], ["class", "d-flex align-items-center justify-content-center", 3, "matTooltipPosition", "matTooltip", "matTooltipClass", 4, "ngIf"], ["class", "video-icon", 4, "ngIf"], ["ngbDropdownMenu", "", "aria-labelledby", "actionsMenu", 1, "dropdown-menu"], ["class", "dropdown-menu dropdown-menu-right", 4, "jhiHasAnyAuthority"], [1, "d-flex", "align-items-center", "justify-content-center", 3, "matTooltipPosition", "matTooltip", "matTooltipClass"], [1, "video-icon"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#video-icon"], [1, "dropdown-menu", "dropdown-menu-right"], [4, "ngIf"], ["id", "session-info-dd-start-zoom-video-call", 1, "dropdown-item", 3, "click"], ["src", "../../../../../../../../../../../../content/images/internal-video-call-icon.svg", "alt", "talking.png", 1, "zoom-video-icon"], ["jhiTranslate", "sessionChat.button.internalVideoCall"], ["jhiTranslate", "sessionChat.button.preferred", 1, "parenthesis"], ["id", "session-info-dd-start-zoom-video-chat", 1, "dropdown-item", 3, "click"], ["src", "../../../../../../../../../../../../content/images/zoom-icon.svg", "alt", "talking.png", 1, "zoom-video-icon"], ["jhiTranslate", "sessionChat.button.zoom"], ["jhiTranslate", "sessionChat.button.backup", 1, "parenthesis"], ["id", "session-info-dd-start-jitsi-video-chat", "class", "dropdown-item", 3, "click", 4, "ngIf"], ["id", "session-info-dd-start-jitsi-video-chat", 1, "dropdown-item", 3, "click"], ["src", "../../../../../../../../../../../../content/images/jitsi-icon.svg", "alt", "talking.png", 1, "jitsi-video-icon"], ["jhiTranslate", "sessionChat.button.jitsi"]], template: function VideoCallDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "button", 2);
        i0.ɵɵtemplate(3, VideoCallDropdownComponent_mat_icon_3_Template, 4, 5, "mat-icon", 3);
        i0.ɵɵtemplate(4, VideoCallDropdownComponent__svg_svg_4_Template, 2, 0, "svg", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, VideoCallDropdownComponent_ng_container_6_Template, 2, 1, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx.session.started || ctx.session.ended);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.session.started);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session.started);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("jhiHasAnyAuthority", "ROLE_COACH");
    } }, directives: [i5.NgbDropdown, i5.NgbDropdownToggle, i6.NgIf, i5.NgbDropdownMenu, i7.HasAnyAuthorityDirective, i8.MatIcon, i9.MatTooltip, i10.JhiTranslateDirective], pipes: [i2.TranslatePipe], styles: [".dropdown-toggle[_ngcontent-%COMP%]{cursor:pointer;color:#44a38d}.dropdown-toggle[_ngcontent-%COMP%]::after{display:none}.video-icon-button[_ngcontent-%COMP%]{height:42px !important;width:42px !important;min-width:42px !important;border-radius:15px}.video-icon[_ngcontent-%COMP%]{height:10px;width:14px}.dropdown-menu[_ngcontent-%COMP%]{min-width:220px !important;top:6px !important;border:none !important;border-radius:10px !important;box-shadow:-3px 0px 30px rgba(0,0,0,.15)}.dropdown-menu[_ngcontent-%COMP%]:before{z-index:10000}.dropdown-item[_ngcontent-%COMP%]{background-color:#fff;color:#44a38d;font-weight:bold}.dropdown-item[_ngcontent-%COMP%]:hover{background-color:#44a38d;color:#fff;font-weight:bold;text-decoration:underline}.dropdown-item[_ngcontent-%COMP%]:hover   .video-icon[_ngcontent-%COMP%]{filter:brightness(0) invert(1) !important}.parenthesis[_ngcontent-%COMP%]{margin-left:5px;color:#d3d3d3}.jitsi-video-icon[_ngcontent-%COMP%], .zoom-video-icon[_ngcontent-%COMP%]{margin-right:10px;margin-bottom:4px}.jitsi-video-icon[_ngcontent-%COMP%]:hover, .zoom-video-icon[_ngcontent-%COMP%]:hover{filter:brightness(0) invert(1) !important}[_nghost-%COMP%]  .video-icon-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}[_nghost-%COMP%]  .video-icon-tool-tip:before{content:\"\";position:absolute;bottom:-11px;right:calc(50% - 10px);border-top:10px solid #44a38b;border-left:10px solid transparent;border-right:10px solid transparent;z-index:10000}"], changeDetection: 0 });
